import React from 'react'

// Bottom-center pill; auto-dismisses ~2.6s after the message changes.
const ArToast = ({ message, onDismiss }) => {
  React.useEffect(() => {
    if (!message) return undefined
    const timer = setTimeout(() => onDismiss && onDismiss(), 2600)
    return () => clearTimeout(timer)
  }, [message, onDismiss])

  if (!message) return null
  return <div className="ar-toast" role="status">{message}</div>
}

export default ArToast
